import Button, { ButtonVariants } from '@/components/new-design/Button';
import { authActionCreator, AuthEvents } from '@/services/auth/authActions';
import { usePrivy } from '@privy-io/react-auth';
import { useDispatch } from 'react-redux';
import { updateRegisteredUser } from '@/services/user/user.service';
import { IoChevronForward } from 'react-icons/io5';
import React from 'react';
import LogoutIcon from '@/components/header/LogoutIcon';

function LogoutButton({ showLabel = true }: { showLabel?: boolean }) {
  const dispatch = useDispatch();
  const { ready, authenticated, logout } = usePrivy();
  // Disable logout when Privy is not ready or the user is not authenticated
  const disableLogout = !ready || (ready && !authenticated);

  const handleLogout = async () => {
    if (disableLogout) return;
    void updateRegisteredUser({ visitorId: null });
    // clear local storage sessions
    await logout();
    localStorage.clear();
    dispatch(authActionCreator(AuthEvents.LOGOUT));
  };
  return (
    <div className="flex w-full items-center !justify-between">
      <Button
        className="w-full !justify-between"
        variant={ButtonVariants.transparent}
        disabled={disableLogout}
        onClick={handleLogout}
      >
        <div className="flex gap-3">
          <LogoutIcon />
          {showLabel && <span className="font-bold text-ph-white-50">Logout</span>}
        </div>
      </Button>
      {showLabel && <IoChevronForward className="text-ph-white-30" />}
    </div>
  );
}

export default LogoutButton;
